import { Outlet, RouterProvider, createBrowserRouter } from 'react-router-dom';
import RootLayout from '~/components/RootLayout';
import RequireAuth from '~/components/auth/RequireAuth';
import AuthLayout from '~/components/auth/AuthLayout';
import MyAccountLayout from '~myAccount/components/Layout';
import { RoutesEnum } from '~/constants/enums';
import { ValuationRoutesEnum } from '~/constants/enums/valuationEnums';
import { WalletRoutesEnum } from '~/constants/enums/walletEnums';
import AddListingLayout from '~addListing/components/Layout';
import { myAccountRoutes } from '~myAccount/routes';
import TopupCheckout from '~myAccount/pages/Wallet/Topup';
import ListingCheckout from '~addListing/pages/ListingCheckout';
import subscriptionRoutes from '~/pages/Subscription/routes';
import packagesRoutes from '~/pages/Packages/routes';
import featureListingRoutes from '~/pages/FeatureListing/routes';
import aqarConnectRoutes from '~/modules/aqarConnect/routes';
import { addListingRoutes } from '~/modules/addListing/routes';
import { PREFIX_ROUTE } from '~/constants';
import { valuationRoutes } from '~valuation/routes';
import { activitiesRoutes } from '~/modules/activities/routes';
import SharedProperties from '~/modules/activities/pages/SharedProperties';
import NotFound from '~/pages/NotFound';
import LeadFollowUp from '~/pages/LeadFollowUp';

export default function Routes() {
  const routers = createBrowserRouter([
    {
      element: <RootLayout />,
      path: `:locale/${PREFIX_ROUTE}/`,
      children: [
        {
          path: RoutesEnum.MY_ACCOUNT,
          element: (
            <RequireAuth>
              <MyAccountLayout />
            </RequireAuth>
          ),
          children: myAccountRoutes,
        },
        {
          path: `${RoutesEnum.MY_ACCOUNT}/${WalletRoutesEnum.TOPUP}`,
          element: (
            <RequireAuth>
              <AuthLayout />
            </RequireAuth>
          ),
          children: [{ index: true, element: <TopupCheckout /> }],
        },
        {
          path: RoutesEnum.SUBSCRIPTION,
          element: <Outlet />,
          children: [...subscriptionRoutes],
        },
        {
          path: RoutesEnum.PACKAGES,
          element: <Outlet />,
          children: [...packagesRoutes],
        },
        {
          path: `${RoutesEnum.MY_LISTING}/:id/${RoutesEnum.FEATURE}`,
          element: (
            <RequireAuth>
              <AuthLayout />
            </RequireAuth>
          ),
          children: [...featureListingRoutes],
        },
        {
          path: `${RoutesEnum.MY_LISTING}/:id/${RoutesEnum.CHECKOUT}`,
          element: (
            <RequireAuth>
              <AuthLayout />
            </RequireAuth>
          ),
          children: [{ index: true, element: <ListingCheckout /> }],
        },
        {
          path: RoutesEnum.MY_LISTING,
          element: <AddListingLayout />,
          children: addListingRoutes,
        },
        {
          path: RoutesEnum.AQAR_CONNECT,
          element: <Outlet />,
          children: [...aqarConnectRoutes],
        },
        {
          path: ValuationRoutesEnum.VALUATION,
          element: (
            <div className="w-full">
              <Outlet />
            </div>
          ),
          children: valuationRoutes,
        },
        {
          path: RoutesEnum.ACTIVITIES,
          element: <Outlet />,
          children: activitiesRoutes,
        },
        {
          path: RoutesEnum.USER_FAVORITES,
          element: <Outlet />,
          children: [
            {
              path: RoutesEnum.USER_FAVORITES_SHARED_NOTES,
              element: <SharedProperties showNotes />,
            },
            {
              path: RoutesEnum.USER_FAVORITES_SHARED,
              element: <SharedProperties />,
            },
          ],
        },
        {
          path: RoutesEnum.LEAD_FOLLOW_UP,
          element: <LeadFollowUp />,
        },
        {
          path: '*',
          element: <NotFound />,
        },
      ],
    },
  ]);
  return <RouterProvider router={routers} />;
}
